import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Warning, EnvelopeOpen } from '@phosphor-icons/react';

export default function VerifyEmailPage() {
  const { token } = useParams();
  const { API, setUser, setCurrentOrg } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState('loading'); // loading | success | error
  const [error, setError] = useState('');

  useEffect(() => {
    axios.post(`${API}/auth/verify-email/${token}`, {}, { withCredentials: true })
      .then(r => {
        setUser(r.data);
        if (r.data?.memberships?.length) {
          const first = r.data.memberships[0];
          setCurrentOrg(first);
          document.cookie = `current_org_id=${first.org_id};path=/;max-age=31536000`;
        }
        setState('success');
        setTimeout(() => navigate('/dashboard'), 1500);
      })
      .catch(err => { setError(err.response?.data?.detail || 'Verification failed'); setState('error'); });
  }, [token, API, setUser, setCurrentOrg, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-purple-50 p-4">
      <Card className="w-full max-w-md">
        <CardContent className="pt-8 pb-6 text-center">
          {state === 'loading' && (
            <>
              <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl flex items-center justify-center mx-auto mb-3">
                <EnvelopeOpen weight="fill" size={24} className="text-white" />
              </div>
              <h1 className="font-['Outfit'] text-xl font-bold text-zinc-900 mb-1">Verifying your email…</h1>
              <p className="text-sm text-zinc-500">Just a moment.</p>
            </>
          )}
          {state === 'success' && (
            <>
              <CheckCircle weight="fill" size={48} className="text-emerald-500 mx-auto mb-3" />
              <h1 className="font-['Outfit'] text-xl font-bold text-zinc-900 mb-2">Email verified!</h1>
              <p className="text-sm text-zinc-500">Taking you to your dashboard…</p>
            </>
          )}
          {state === 'error' && (
            <>
              <Warning weight="fill" size={48} className="text-red-500 mx-auto mb-3" />
              <h1 className="font-['Outfit'] text-xl font-bold text-zinc-900 mb-2">Verification failed</h1>
              <p className="text-sm text-zinc-500 mb-4">{error}</p>
              <Button onClick={() => navigate('/login')}>Go to Login</Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
